module.exports = __webpack_public_path__ + "static/media/alert-star-zoom.ba07126e.png";